export default "__VITE_ASSET__CjB2VAxt__"